<app-centered-card-layout title="Verification required" subtitle="Enter the OTP sent to your email.">
  <div card-content class="fx-col fx-center fx-gap-20">
    <span class="mat-caption pl-10">For improved security, we need to verify your account using the One Time Pin that was sent to your email.</span>
    <ng-otp-input
      #ngOtpInput
      (onInputChange)="onOtpChange($event)"
      [config]="{
              length: 4,
              allowNumbersOnly: true,
              containerClass: 'otp-wrapper-element',
              inputClass: 'otp-input-element'
            }"
    ></ng-otp-input>
    <mat-error *ngIf="errMessage">{{ errMessage }}</mat-error>

    <button color="primary" class="action-button-large"
            mat-raised-button
            (click)="onVerify()" [disabled]="loading || len < 4 || (loader.loading$ | async)">
      <div class="button-text">{{ loading ? 'Working...' : 'Verify' }}</div>
      <mat-icon *ngIf="loading">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>
    </button>
  </div>
  <div card-actions class="fx-row-w-100 fx-space-between pl-16 pr-16">
    Didn’t receive an OTP?
    <button mat-button color="accent" (click)="!loading ? onResendOTP() : null" [routerLink]=""
            class="link-text btn-cursor">Resend OTP.
    </button>
  </div>
</app-centered-card-layout>
